<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="page-title-box">
          <div class="float-right">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);">BPD BALI</a>
              </li>
              <li class="breadcrumb-item active">Setting</li>
            </ol>
          </div>

          <h4 class="page-title">Setting</h4>
        </div>
      </div>
    </div>

    <div>
      <form @submit.prevent="submitForm()">
        <div class="card">
          <div class="card-body">
            <div class="mb-3">
              Note : Gunakan
              <span class="badge badge-primary">{{ instance_name }}</span> untuk
              menampilkan nama perusahaan dan
              <span class="badge badge-primary">{{ instance_code }}</span> untuk
              menampilkan code perusahaan
              <span class="badge badge-primary">{{ bill_no }}</span> untuk
              menampilkan VA number
              <span class="badge badge-primary">{{ customer_code }}</span> untuk
              menampilkan Nomor ID
            </div>

            <div class="form-group">
              <label>Format Label Pembayaran VA</label>
              <vue-editor
                v-model="invoice_va_payment_format"
                :editorToolbar="customToolbar"
              ></vue-editor>
            </div>

            <div class="form-group">
              <label>Format Label Pembayaran QRIS</label>
              <vue-editor
                v-model="invoice_qris_payment_format"
                :editorToolbar="customToolbar"
              ></vue-editor>
            </div>
          </div>
        </div>

        <button
          class="btn btn-success waves-effect waves-light mb-5"
          :disabled="loading"
        >
          Simpan Setting
          <div
            class="spinner-border text-light ml-2"
            role="status"
            v-if="loading"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </button>

        <br />
      </form>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      instance_name: "{{instance_name}}",
      instance_code: "{{instance_code}}",
      bill_no: "{{va_number}}",
      customer_code: "{{customer_code}}",
      loading: false,
      invoice_va_payment_format: "",
      invoice_qris_payment_format: "",
      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          {
            align: "",
          },
          {
            align: "center",
          },
          {
            align: "right",
          },
          {
            align: "justify",
          },
        ],
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
          {
            list: "check",
          },
        ],
      ],
    };
  },
  components: {
    VueEditor,
  },
  validations() {},
  methods: {
    submitForm() {
      this.loading = true;

      this.$http({
        method: "POST",
        url: `${this.API_URL}setting/update`,
        data: {
          invoice_va_payment_format: this.invoice_va_payment_format,
          invoice_qris_payment_format: this.invoice_qris_payment_format,
        },
        headers: {
          Authorization: `Bearer ${this.$cookies.get("token_admin")}`,
        },
      })
        .then((response) => {
          const result = response.data;
          if (result.success) {
            this.sAlert("success", "Berhasil simpan settingan!");
          } else {
            this.sAlert("error", result.message);
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.sAlert("error", "Error, Terjadi Kesalahan!");
        });
    },
  },
  mounted() {
    this.loadingInitial = true;
    // LOAD DATA
    this.$http
      .get(`${this.API_URL}setting`, {
        headers: {
          Authorization: `Bearer ${this.$cookies.get("token_admin")}`,
        },
      })
      .then((response) => {
        this.loadingInitial = false;
        const result = response.data;

        if (result.success) {
          this.invoice_va_payment_format =
            result.data.invoice_va_payment_format;
          this.invoice_qris_payment_format =
            result.data.invoice_qris_payment_format;
        } else {
          this.sAlert("error", result.message);
        }
        this.loading = false;
      })
      .catch((error) => {
        this.loadingInitial = false;
        this.sAlert("error", "Error, Terjadi Kesalahan!");
      });
  },
};
</script>